import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  CustomerPortalAccessStatus,
  PortalAccessRequest,
  PortalAccessView,
  PortalAdminRoleOption
} from './customer-portal-admin.model';

@Injectable({
  providedIn: 'root'
})
export class CustomerPortalAdminService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.restApiUrl}customer-portal-admin`;

  listAccess(): Observable<PortalAccessView[]> {
    return this.http.get<PortalAccessView[]>(`${this.apiUrl}/access`);
  }

  saveAccess(request: PortalAccessRequest): Observable<PortalAccessView> {
    return this.http.post<PortalAccessView>(`${this.apiUrl}/access`, request);
  }

  updateStatus(accessId: number, status: CustomerPortalAccessStatus): Observable<PortalAccessView> {
    return this.http.patch<PortalAccessView>(`${this.apiUrl}/access/${accessId}/status`, { status });
  }

  replaceRoles(accessId: number, roleIds: number[]): Observable<PortalAccessView> {
    return this.http.put<PortalAccessView>(`${this.apiUrl}/access/${accessId}/roles`, { roleIds });
  }

  getRoles(): Observable<PortalAdminRoleOption[]> {
    return this.http.get<PortalAdminRoleOption[]>(`${this.apiUrl}/roles`);
  }
}
